var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 59,
    viewBox: "0 0 72 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_2329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 4.09375C72 1.97168 70.2723 0.25 68.1429 0.25H3.85714C1.71964 0.25 9.53674e-07 1.97168 9.53674e-07 4.09375C9.53674e-07 6.22383 1.71964 7.9375 3.85714 7.9375H68.1429C70.2723 7.9375 72 6.22383 72 4.09375ZM72 29.7188C72 27.5887 70.2723 25.875 68.1429 25.875H24.4286C22.2911 25.875 20.5714 27.5887 20.5714 29.7188C20.5714 31.8488 22.2911 33.5625 24.4286 33.5625H68.1429C70.2723 33.5625 72 31.8488 72 29.7188ZM45 59.1875H68.1429C70.2723 59.1875 72 57.4738 72 55.3438C72 53.2137 70.2723 51.5 68.1429 51.5H45C42.8625 51.5 41.1429 53.2137 41.1429 55.3438C41.1429 57.4738 42.8625 59.1875 45 59.1875Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_2329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 59,
    fill: "white",
    transform: "matrix(-1 0 0 1 72 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.7bb99ece0ee2c10a5357645aa155a1b6.svg";
export { ForwardRef as ReactComponent };